import classNames from 'classnames';
import {withTranslation, WithTranslation} from 'react-i18next';

import {TRANSLATION_KEYS} from 'locale/translation-keys';

import './styles.scss';

const T_KEYS = TRANSLATION_KEYS.UI_KIT.CALL_STATUS;

type Status = 'no response' | 'in touch' | 'awaiting' | 'awaiting-hold';

const T_KEY_STATUS: {[key in Status]: string} = {
    'no response': T_KEYS.NO_RESPONSE,
    'in touch': T_KEYS.IN_TOUCH,
    awaiting: T_KEYS.AWAITING,
    'awaiting-hold': T_KEYS.AWAITING,
};

type Props = {
    status?: Status,
    size?: 'xs' | 'small' | 'medium' | 'large'
    className?: string;
} & WithTranslation;

const SessionStatus: React.FC<Readonly<Props>> = ({className, t, size = 'xs', status = 'no response'}: Readonly<Props>) => (
    <span className={classNames(`vs-session-status ${size}`, className, {
        'no-response': status === 'no response',
        'in-touch': status === 'in touch',
        awaiting: status === 'awaiting',
        'awaiting-hold': status === 'awaiting-hold'
    })}
    >
        {t(T_KEY_STATUS[status])}
    </span>
);

const wrappedComponents = withTranslation()(SessionStatus);

export {wrappedComponents as SessionStatus};